import React, { useState, useEffect } from 'react';
import {getArchiveAccountStatement} from '../services/depositService';
import { useAuth } from "../auth/AuthContext";
import errorMessages from '../constants/errorMessages';
import LoadingSpinnerComponent from '../components/LoadingSpinnerComponent';
import theme from '../theme/theme';

const ArchiveAccountStatement = () => {
   const [accountData, setAccountData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { empIdNumber } = useAuth();

  useEffect(() => {
    const loadAccountStatement = async () => {
      try {
        const data = await getArchiveAccountStatement(empIdNumber);
        setAccountData(data);
        setLoading(false);
      } catch (error) {
        setError(errorMessages.FETCH_DATA_ERROR);
        console.error(error);
        setLoading(false);
      } finally{
        setLoading(false);
      }
    };

    loadAccountStatement();
  }, []);

  if (loading) return <LoadingSpinnerComponent spinnerColor={theme.colors.secondary}/>
  if (error) return <div>{error}</div>;

  return (
   <div className="table-responsive container my-4">
  <table 
    className="table table-hover table-bordered align-middle text-center fs-5" 
    dir="rtl"
    style={{ borderRadius: '12px', overflow: 'hidden' }}
  >
    <thead className="table-success">
      <tr>
        <th scope="col" className="fw-bold py-3">السنة</th>
        <th scope="col" className="fw-bold py-3">الإيداعات</th>
        <th scope="col" className="fw-bold py-3">الرصيد</th>
      </tr>
    </thead>
    <tbody>
      {accountData?.length ? (
        accountData.map((statement, index) => (
          <tr key={index} style={{ fontSize: '1.25rem' }}>
            <td className="fw-semibold text-primary py-3">{statement.depositYear}</td>
            <td className="fw-semibold py-3">{statement.depositsCount}</td>
            <td className="fw-semibold text-success py-3">{statement.score}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="3" className="text-muted py-4 fs-5">لا توجد بيانات</td>
        </tr>
      )}
    </tbody>
  </table>
</div>
  );
};

export default ArchiveAccountStatement;
